module.exports = __webpack_public_path__ + "static/img/11.1914a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/eventBanner/11.jpg
// module id = IyZG
// module chunks = 9